import React from 'react';
import { ImageFile } from '~/data/types/images';

const StarPromotionCardIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 49"
    >
      <path
        d="M24.2829 2.21875C23.062 7.84357 16.896 19.0932 2 19.0932"
        stroke="#FFE500"
        strokeWidth={3.24509}
        strokeLinecap="round"
      />
      <path
        d="M24.2838 41.8047C25.1491 36.252 29.5192 25.1466 40.0765 25.1466"
        stroke="#FFE500"
        strokeWidth={3.24509}
        strokeLinecap="round"
      />
      <path
        d="M24.2838 2C25.1491 9.7161 29.5192 25.1483 40.0765 25.1483"
        stroke="#FFE500"
        strokeWidth={3.24509}
        strokeLinecap="round"
      />
      <path
        d="M24.2829 41.8047C23.062 34.2328 16.896 19.0891 2 19.0891"
        stroke="#FFE500"
        strokeWidth={3.24509}
        strokeLinecap="round"
      />
      <path
        d="M51.3042 25.0547C50.6215 28.1996 47.1741 34.4893 38.8457 34.4893"
        stroke="#FFE500"
        strokeWidth={1.81434}
        strokeLinecap="round"
      />
      <path
        d="M51.3047 47.1875C51.7885 44.083 54.2318 37.8739 60.1345 37.8739"
        stroke="#FFE500"
        strokeWidth={1.81434}
        strokeLinecap="round"
      />
      <path
        d="M51.3047 24.9297C51.7885 29.2438 54.2318 37.872 60.1345 37.872"
        stroke="#FFE500"
        strokeWidth={1.81434}
        strokeLinecap="round"
      />
      <path
        d="M51.3042 47.1875C50.6215 42.954 47.1741 34.4871 38.8457 34.4871"
        stroke="#FFE500"
        strokeWidth={1.81434}
        strokeLinecap="round"
      />
    </Component>
  );
};

export default StarPromotionCardIcon;
